<template>
    <div v-if="user" v-route-title="projectName">
        <div class="header header-wraper">
            <el-menu
                    router :default-active="activePath"
                    class="yq-menubar"
                    mode="horizontal"
                    background-color="#0E192E"
                    text-color="#F4F6F8"
                    active-text-color="#FC8F22"
                    >
                <h1 class="logo-personal clearfix ng-scope"> <a class="logo-link">{{projectName}}</a> </h1>
                <el-submenu index="2" v-if="hasAuthority('T_前台用户')">
                    <template slot="title">门户</template>
                    <el-menu-item v-for="portal in portals" :key="portal.id" :index="'/main/portals/'+portal.id">{{portal.name}}</el-menu-item>
                </el-submenu>
                <el-menu-item index="/main/project-admin" v-if="hasAuthority('P_后台_管理_项目')">项目库</el-menu-item>
                <el-menu-item index="/main/portal-admin" v-if="hasAuthority('P_前台_管理_门户')">门户管理</el-menu-item>
                <el-menu-item index="/main/section-admin" v-if="hasAnyAuthority('P_后台_管理_栏目', 'P_前台_管理_栏目')">栏目管理</el-menu-item>
                <el-menu-item index="/main/template-admin" v-if="hasAnyAuthority('P_后台_管理_模板', 'P_前台_管理_模板')">模板管理</el-menu-item>
                <el-menu-item index="/main/view-style-admin" v-if="hasAuthority('P_后台_管理_样式模板')">样式模板管理</el-menu-item>
                <el-menu-item index="/main/data-admin" v-if="hasAnyAuthority('P_后台_管理_数据', 'P_前台_管理_数据')">数据管理</el-menu-item>
                <el-menu-item index="/main/datasource-config-admin" v-if="hasAuthority('P_后台_管理_系统')">数据源管理</el-menu-item>
                <el-submenu index="8" v-if="hasAnyAuthority('P_后台_管理_系统', 'P_前台_管理_系统')">
                    <template slot="title">系统管理</template>
                    <el-menu-item index="/main/user-admin">用户管理</el-menu-item>
                    <el-menu-item index="/main/usergroup-admin">用户组管理</el-menu-item>
                    <el-menu-item index="/main/role-admin">角色管理</el-menu-item>
                    <el-menu-item index="/main/user-log-admin" v-if="hasAuthority('P_后台_管理_系统')">用户日志管理</el-menu-item>
                </el-submenu>
                <div class="yq-menubar-user">
                    <div class="yq-menubar-user-info">
                        <img src="../assets/images/avator.png">
                        <div>{{user.nickName||user.name}}</div>
                    </div>
                    <div class="yq-menubar-user-buttons">
                        <img src="../assets/images/tixing.png">
                        <img src="../assets/images/tuichu.png" @click="logout">
                    </div>
                </div>
            </el-menu>
        </div>
        <div class="main header-wraper-height">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import portalService from '../service/portal'

    export default {
        name: 'MainPage',
        data() {
            return {
                portals: [],
                activePath: null
            }
        },
        computed: {
            ...mapState(['user']),
            ...mapGetters(['hasAuthority', 'hasAnyAuthority']),
            projectName(){
                if(this.user&&this.user.project){
                    return this.user.project.name
                }else{
                    return '舆情系统'
                }
            }
        },
        created(){
            this.init()
        },
        beforeRouteUpdate (to, from, next) {
            this.activePath = to.path
            next()
        },
        methods: {
            ...mapActions(['logout']),
            async init(){

                if(this.hasAuthority('T_前台用户')){
                    const response = await portalService.listPortals({page:0, size: 10})
                    this.portals = response.data.content
                }
            }
        }
    }
</script>
